export default {"src":"/_next/static/media/icon_skillz_rewardz.e5621fd1.svg","height":20,"width":17,"blurWidth":0,"blurHeight":0};